export default "/static/build/a-plus-rating.png";